import React, { useEffect, useRef } from 'react';
import { Box, ModuleBase, Text, Stack, Link } from '@/components';
import classNames from 'classnames';

import { SideBySideModuleModel } from './SideBySideModule';
import { loadScriptsParallel, parseCMSScripts } from '@/utils';

const BookADemoForm = (data: SideBySideModuleModel) => {
  const { alignment, title, description, link1, script } = data.props;

  const divElement = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let scriptElement: HTMLScriptElement | null = null;

    const parseScripts = async () => {
      if (script) {
        const parsedScripts = parseCMSScripts(script);
        if (parsedScripts) {
          await loadScriptsParallel(parsedScripts.scripts);

          if (parsedScripts.vanillaScripts && divElement.current) {
            scriptElement = document.createElement('script');
            scriptElement.type = 'text/javascript';
            scriptElement.text = parsedScripts.vanillaScripts.innerHTML; // <-- your API code here
            divElement.current.appendChild(scriptElement);
          }
        }
      }
    };

    parseScripts();
    return () => {
      scriptElement?.remove();
    };
  }, []);

  return (
    <ModuleBase data={{ ...data, props: { ...data.props, backgroundColour: '#f1f0e9' } }} className="BookADemoForm">
      <Stack
        className={classNames(
          'relative container flex flex-col gap-10 xl:gap-24',
          alignment === 'Right' ? 'lg:flex-row-reverse' : 'lg:flex-row',
        )}
      >
        <div className="flex w-full flex-col gap-10 lg:w-1/2">
          {title && (
            <Text
              className="text-style-h2 pr-10 md:pr-20 lg:pr-0 xl:!text-[75px] xl:!leading-[75px]"
              dangerouslySetInnerHTML={{ __html: title }}
            />
          )}

          <div className="color-from-bg relative flex w-fit flex-col">
            {description && (
              <Text
                className="text-style-h4 [&_h5]:text-style-body"
                dangerouslySetInnerHTML={{ __html: description }}
              />
            )}
            {link1 && <Link animate className="btn primary v2 mt-10 !text-[#f1f0e9]" link={link1} />}
          </div>
        </div>

        <Box className="w-full bg-white px-5 py-2 md:px-10 lg:w-1/2 lg:py-5">
          <div ref={divElement} />
        </Box>
      </Stack>
    </ModuleBase>
  );
};

export default BookADemoForm;
